// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1776":"css/customer-frontend","2337":"css/analysis","2732":"css/includes","4501":"css/backend","5887":"css/frontend","6730":"css/scrollable-video","8748":"css/passkeys","9637":"css/share_Banner"}[chunkId] + ".css";
};